import { useState } from "react";
import { describeSubmitError } from "../utils/submitError";

export type SubmitStatus = "idle" | "submitting" | "success" | "error";

/** Tracks one form's send: idle → submitting → success or error. */
export function useFormSubmit<Payload>(send: (payload: Payload) => Promise<void>) {
  const [status, setStatus] = useState<SubmitStatus>("idle");
  const [errorMessage, setErrorMessage] = useState("");

  async function submit(payload: Payload) {
    setStatus("submitting");
    setErrorMessage("");
    try {
      await send(payload);
      setStatus("success");
    } catch (error) {
      setErrorMessage(describeSubmitError(error));
      setStatus("error");
    }
  }

  function reset() {
    setStatus("idle");
    setErrorMessage("");
  }

  return { status, errorMessage, submit, reset };
}
